import { useI18n } from "../../i18n";

const IntroComponent = ({ title, description }) => {
  const { t } = useI18n();

  return (
    <div className="md:w-1/2 flex flex-col items-center justify-center bg-gradient-to-br from-indigo-500 via-purple-500 to-fuchsia-500 p-10 text-center relative overflow-hidden">
      {/* Dekorativ dairələr */}
      <div className="absolute -top-16 -left-16 w-48 h-48 bg-white/10 rounded-full" />
      <div className="absolute -bottom-20 -right-10 w-64 h-64 bg-white/10 rounded-full" />

      <span className="text-6xl mb-4 relative">🎯</span>
      <h3 className="text-3xl font-extrabold text-white mb-3 relative">
        {title}
      </h3>
      <p className="text-indigo-100 relative leading-relaxed max-w-sm">
        {description}
      </p>

      <div className="relative mt-8 flex gap-6 text-white/90 text-sm font-medium">
        <div className="flex flex-col items-center">
          <span className="text-2xl mb-1">🧠</span>
          {t("auth.intro_play")}
        </div>
        <div className="flex flex-col items-center">
          <span className="text-2xl mb-1">✅</span>
          {t("auth.intro_answer")}
        </div>
        <div className="flex flex-col items-center">
          <span className="text-2xl mb-1">🎁</span>
          {t("auth.intro_win")}
        </div>
      </div>
    </div>
  );
};

export default IntroComponent;
